export default __webpack_public_path__ + "static/media/icn-megaphone-active.028a6f21.svg";